export default __webpack_public_path__ + "static/media/flag-at.a6afeb23.svg";